function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["checked", "onChange", "renderLeft", "renderRight", "style", "uiTheme", "preset"];
var _templateObject;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React, { Component } from 'react';
import styled from 'styled-components';
import { merge, isNumber } from 'lodash';
import Cushion from '../Cushion';
import { getPreset } from '../Theme/selectors';
import Rectangle from '../Rectangle';
import Shadow from '../Shadow';
import Space from '../Space';
import Typography from '../Typography';
import withTheme from '../Theme/withTheme';
var ActiveItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  height: ", "\n  width: ", ";\n  box-sizing: border-box;\n  top: 50%;\n  left: ", ";\n  zIndex: 1;\n  transform: ", ";\n  transition: left 300ms cubic-bezier(0.18, 0.89, 0.35, 1.15), all 300ms ease;\n\n  input:active +  & {\n    width: 70%;\n  }\n"])), function (props) {
  return "calc(100% - ".concat(props.gap * 2, "px);");
}, function (props) {
  return isNumber(props.width) ? "".concat(props.width, "px") : props.width;
}, function (props) {
  return props.checked ? "calc(100% - ".concat(props.gap, "px)") : "".concat(props.gap, "px");
}, function (props) {
  return props.checked ? 'translate(-100%, -50%)' : 'translateY(-50%)';
});
var Switch = /*#__PURE__*/function (_Component) {
  function Switch() {
    var _this;
    _classCallCheck(this, Switch);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Switch, [].concat(args));
    _defineProperty(_this, "state", {
      width: '50%',
      height: null
    });
    _defineProperty(_this, "checkedRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "uncheckedRef", /*#__PURE__*/React.createRef());
    _defineProperty(_this, "getRefDimensions", function () {
      return {
        checkedWidth: _this.checkedRef.current.clientWidth,
        checkedHeight: _this.checkedRef.current.clientHeight,
        uncheckedWidth: _this.uncheckedRef.current.clientWidth,
        uncheckedHeight: _this.uncheckedRef.current.clientHeight
      };
    });
    _defineProperty(_this, "setDimensions", function (_ref) {
      var width = _ref.width,
        height = _ref.height;
      _this.setState(function () {
        return {
          width: width,
          height: height
        };
      });
    });
    _defineProperty(_this, "calculateWidth", function (checkedWidth, uncheckedWidth) {
      return checkedWidth > uncheckedWidth ? checkedWidth : uncheckedWidth;
    });
    _defineProperty(_this, "calculateHeight", function (checkedHeight, uncheckedHeight) {
      var toNextEventNumber = function toNextEventNumber(number) {
        return 2 * Math.round(number / 2);
      };
      return checkedHeight > uncheckedHeight ? toNextEventNumber(checkedHeight) : toNextEventNumber(uncheckedHeight);
    });
    return _this;
  }
  _inherits(Switch, _Component);
  return _createClass(Switch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$getRefDimension = this.getRefDimensions(),
        checkedWidth = _this$getRefDimension.checkedWidth,
        checkedHeight = _this$getRefDimension.checkedHeight,
        uncheckedWidth = _this$getRefDimension.uncheckedWidth,
        uncheckedHeight = _this$getRefDimension.uncheckedHeight;
      var width = this.calculateWidth(checkedWidth, uncheckedWidth);
      var height = this.calculateHeight(checkedHeight, uncheckedHeight);
      this.setDimensions({
        width: width,
        height: height
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$getRefDimension2 = this.getRefDimensions(),
        checkedWidth = _this$getRefDimension2.checkedWidth,
        checkedHeight = _this$getRefDimension2.checkedHeight,
        uncheckedWidth = _this$getRefDimension2.uncheckedWidth,
        uncheckedHeight = _this$getRefDimension2.uncheckedHeight;
      var width = this.calculateWidth(checkedWidth, uncheckedWidth);
      var height = this.calculateHeight(checkedHeight, uncheckedHeight);
      if (prevState.width !== width || prevState.height !== height) {
        this.setDimensions({
          width: width,
          height: height
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var gap = 2;
      var _this$state = this.state,
        width = _this$state.width,
        height = _this$state.height;
      var _this$props = this.props,
        checked = _this$props.checked,
        onChange = _this$props.onChange,
        renderLeft = _this$props.renderLeft,
        renderRight = _this$props.renderRight,
        customStyle = _this$props.style,
        uiTheme = _this$props.uiTheme,
        presetName = _this$props.preset,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var preset = getPreset(uiTheme, 'switch', presetName);
      var visualProps = merge({}, preset, _objectSpread({}, otherProps));
      var checkedOptions = visualProps.checkedOptions,
        uncheckedOptions = visualProps.uncheckedOptions;
      var colorOptions = checked ? checkedOptions : uncheckedOptions;
      var renderContent = function renderContent(func, color) {
        return /*#__PURE__*/React.createElement(Typography, {
          align: "center",
          lineHeight: "0",
          color: color,
          component: "div",
          style: {
            whiteSpace: 'nowrap'
          }
        }, func());
      };
      return /*#__PURE__*/React.createElement(Cushion, {
        vertical: gap,
        style: customStyle
      }, /*#__PURE__*/React.createElement(Rectangle, {
        radius: 9999,
        fill: colorOptions.fill,
        style: {
          position: 'relative',
          display: 'inline-block',
          overflow: 'hidden',
          transition: 'background-color 300ms ease'
        }
      }, /*#__PURE__*/React.createElement("input", {
        key: "checkbox",
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        style: {
          position: 'absolute',
          height: '100%',
          width: '100%',
          top: 0,
          left: 0,
          zIndex: 3,
          cursor: 'pointer',
          opacity: 0,
          margin: 0
        }
      }), /*#__PURE__*/React.createElement(Shadow, {
        shadow: colorOptions.toggle.shadow
      }, /*#__PURE__*/React.createElement(Cushion, {
        vertical: 6
      }, /*#__PURE__*/React.createElement(Rectangle, {
        fill: colorOptions.toggle.fill,
        radius: 9999
      }, /*#__PURE__*/React.createElement(ActiveItem, {
        checked: checked,
        gap: gap,
        width: width
      }, checked ? renderContent(renderRight, colorOptions.toggle.color) : renderContent(renderLeft, colorOptions.toggle.color))))), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          height: '100%',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement(Space, {
        left: gap
      }, /*#__PURE__*/React.createElement(Cushion, {
        horizontal: 12,
        vertical: 6,
        style: {
          boxSizing: 'border-box',
          width: width,
          height: height || 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.uncheckedRef
      }, renderContent(renderLeft, colorOptions.color)))), /*#__PURE__*/React.createElement(Space, {
        right: gap
      }, /*#__PURE__*/React.createElement(Cushion, {
        horizontal: 12,
        vertical: 6,
        style: {
          boxSizing: 'border-box',
          width: width,
          height: height || 'auto'
        }
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.checkedRef
      }, renderContent(renderRight, colorOptions.color)))))));
    }
  }]);
}(Component);
Switch.defaultProps = {
  checkedOptions: undefined,
  preset: 'default',
  renderLeft: function renderLeft() {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: 12
      }
    });
  },
  renderRight: function renderRight() {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: 12
      }
    });
  },
  style: {},
  uiTheme: {},
  uncheckedOptions: undefined
};
Switch.displayName = 'Switch';
export default withTheme(Switch);